import { css } from "styled-components";

export const errorStyles = (props) => css`
  border: 1px solid
    ${(props) =>
      !props.error ? props.theme.colors.danger : props.theme.colors.darkGray};
  border-color: ${(props) =>
    !props.error ? props.theme.colors.danger : props.theme.colors.darkGray};
  background-color: ${(props) =>
    !props.error ? props.theme.colors.dangerLight : props.theme.colors.white};
  &:focus {
    outline-color: ${(props) => !props.error && props.theme.colors.dangerLight};
    border: ${(props) =>
      !props.error && `2px solid ${props.theme.colors.danger}`};
    border-color: ${(props) => !props.error && props.theme.colors.danger};
  }
`;
export const colorStyles = ({ theme, error, disabled }) => {
  if (error) return theme.colors.danger;
  else if (disabled) return theme.colors.darkGray;
  else return theme.colors.black;
};
